import BaseStore from 'core/stores/BaseStore';
import { action } from 'mobx';
import { ReportService } from 'common/data';

class ReportStore extends BaseStore {
	constructor(rootStore) {
		super(new ReportService(rootStore.app.baasic.apiClient));
	}

	@action
	findReports = async filter => {
		const response = await this.service.find(filter);
		this.response = response.data;
	};

	@action
	getReport = async (id, options) => {
		const report = await this.service.get(id, options);
		this.item = report.data;
		return report.data;
	};

	@action
	createReport = async (report, sourceOfChange) => {
		const response = await this.service.create(report, sourceOfChange);
		return response.data;
	};

	@action
	updateReport = async (report, sourceOfChange) => {
		await this.service.update(report, sourceOfChange);
	};

	@action
	deleteReport = async report => {
		await this.service.delete(report);
	};

	@action
	sendReport = async sendReportParams => {
		const response = await this.service.sendReport(sendReportParams);
		return response.data;
	};
}

export default ReportStore;
